import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // this is needed!
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTabsModule } from '@angular/material/tabs';

import {
  MatCommonModule,
  MatLineModule,
  MatNativeDateModule,
  MatOptionModule,
  MatPseudoCheckboxModule,
  MatRippleModule,
} from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatToolbarModule } from '@angular/material/toolbar';

import { MatTableExporterModule } from 'mat-table-exporter';

// Register the plugin

import { ExhibitorsViewComponent } from './exhibitor-view.component';
import { PhutureIavatarModule } from '../@components/phuture-iavatar/phuture-iavatar.module';
import { SharedModule } from '../@shared/shared.module';

@NgModule({
  declarations: [ExhibitorsViewComponent],
  imports: [
    CommonModule,
    FormsModule,
    FormsModule,
    ReactiveFormsModule,

    CardModule,
    ButtonModule,
    MenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatRippleModule,
    MatSidenavModule,
    MatIconModule,
    MatChipsModule,
    MatToolbarModule,
    MatTabsModule,

    MatTableExporterModule,

    PhutureIavatarModule,
    SharedModule,
  ],
  exports: [ExhibitorsViewComponent],
})
export class ExhibitorsViewModule {}
